import { Box, HStack, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { DoneIcon } from 'icons/DoneIcon';
import { Lightning } from 'icons/Lightingİcon';
import { SecurityIcon } from 'icons/SecurityIcon';

export const Hero: React.FC = () => {
  return (
    <Stack direction={{ base: 'column', lg: 'row' }} align="center" py={12}>
      <VStack align="start" flex={1} pb={3}>
        <Heading as="h1" size="2xl" lineHeight={1.2} fontWeight={700}>
          Rahat və Sadə Satış Sistemləri
        </Heading>

        <Text fontSize="lg" color="gray.600" maxW="600px">
          Masaüstü, Veb və Mobil cihazlar üçün etibarlı, təhlükəsiz, çevik və güclü satış
          platforması.
        </Text>

        <HStack pt={4}>
          <HStack border="1px solid #e5e7eb;" borderRadius="10px" gap={1} p={'3px 7px'}>
            <SecurityIcon />
            <Text color={'black'} fontWeight={'500'} fontSize="12px">
              Təhlükəsiz
            </Text>
          </HStack>

          <HStack border="1px solid #e5e7eb;" borderRadius="10px" gap={1} p={'3px 7px'}>
            <Lightning />
            <Text color={'black'} fontWeight={'500'} fontSize="12px">
              Sürətli
            </Text>
          </HStack>

          <HStack border="1px solid #e5e7eb;" borderRadius="10px" gap={1} p={'3px 7px'}>
            <DoneIcon />
            <Text color={'black'} fontWeight={'500'} fontSize="12px">
              Etibarlı
            </Text>
          </HStack>
        </HStack>
      </VStack>

      <Box w={{ base: '100%', md: '50%' }}>
        <Image
          w="100%"
          height={'100%'}
          objectFit={'contain'}
          src="/assets/image.png"
          borderRadius={'16px'}
        />
      </Box>
    </Stack>
  );
};
